import { render, staticRenderFns } from "./StudentPersonalDataInfo.vue?vue&type=template&id=d1c5b59e"
import script from "./StudentPersonalDataInfo.vue?vue&type=script&lang=js"
export * from "./StudentPersonalDataInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports